import type {PageMigrator} from '../dataMigrationRunner'
import {type DocumentManager, pointerUtils} from '@wix/document-manager-core'
import type {DalValue} from '@wix/document-services-types'
import type {PageAPI} from '../../../page'
import _ from 'lodash'
import {deepClone} from '@wix/wix-immutable-proxy'
import {DATA_TYPES} from '../../../../constants/constants'

const {getPointer} = pointerUtils

const fixObject = (obj: any) => {
    if (obj.bindingItemType === 'Method') {
        obj.bindingItemType = 'ContextMethod'
    }
}

const fixObject2 = (obj: any) => {
    if (obj.bindingItemType === 'ContextMethod') {
        obj.bindingItemType = 'TemplateMethod'
    }
    if (obj.bindingItemType === 'ContextItem') {
        obj.bindingItemType = 'TemplateItem'
    }
}

const migratePage = (documentManager: DocumentManager, pageId: string) => {
    const {experimentInstance} = documentManager
    if (!experimentInstance.isOpen('dm_employeesFixBindingType')) {
        return
    }
    const {dal, extensionAPI} = documentManager
    // Fix potential ContextBindingConfig
    const objectsToCheck = dal.query(
        DATA_TYPES.bindings,
        (extensionAPI.page as PageAPI).getPageIndexId(pageId),
        comp => comp?.type === 'ContextBindingConfig'
    )
    _.forEach(objectsToCheck, (item: DalValue) => {
        const _item = deepClone(item)
        _.forEach(_item.properties, (value: any) => {
            fixObject(value)
        })
        dal.set(getPointer(_item.id, DATA_TYPES.bindings), _item)
    })
    // Fix potential TemplateBindingConfig
    const objectsToCheck2 = dal.query(
        DATA_TYPES.bindings,
        (extensionAPI.page as PageAPI).getPageIndexId(pageId),
        comp => comp?.type === 'TemplateBindingConfig'
    )
    _.forEach(objectsToCheck2, (item: DalValue) => {
        const _item = deepClone(item)
        if (_item.listItemPath) {
            delete _item.listItemPath
        }
        _.forEach(_item.properties, (value: any) => {
            fixObject2(value)
        })
        dal.set(getPointer(_item.id, DATA_TYPES.bindings), _item)
    })
}

const experimentalVersions = [{experiment: 'dm_employeesFixBindingType', version: 3}]

export const fixContextMethodName: PageMigrator = {
    migratePage,
    name: 'fixContextMethodName',
    version: 2,
    experimentalVersions
}
